import { baseAPI } from "../baseApi"

type FetchRoadDocumentsArgs = {
    roadId?: string
}

export const documentsApiSlice = baseAPI.injectEndpoints({
    endpoints: builder => ({
        // запрос на получение типов документов
        fetchDocumentsTypes: builder.query<any, any>({
            query: () => ({
                url: `documents/types`
            }),
        }),
        // запрос на получение общей протяженности опорной сети
        fetchRoadDocuments: builder.query<any, FetchRoadDocumentsArgs>({
            query: ({ roadId }) => ({
                url: `address/Roads(${roadId})/Documents`
            })
        }),
        // запрос на получение документов объекта
        fetchObjectDocuments: builder.query<any, any>({
            query: ({ urlType, objectType, objectId }: any) => ({
                url: `${urlType}/${objectType}(${objectId})/DocumentLinks`
            })
        }),
        // запрос на получение информации о правовом документе
        fetchRoadLandRightDocumentInfo: builder.query<any, any>({
            query: ({ id }: any) => ({
                url: `documents/RoadLandRightDocs(${id})`
            })
        })
    })
})

export const {
    useFetchDocumentsTypesQuery,
    useFetchRoadDocumentsQuery,
    useFetchObjectDocumentsQuery,
    useFetchRoadLandRightDocumentInfoQuery,
    useLazyFetchRoadLandRightDocumentInfoQuery,
} = documentsApiSlice